import { useMemo } from 'react'

import { sumOvernightFeesForPosition } from '../utils/DxtradeCashTransfersFields'
import { useDxtradeCashTransfers } from './useDxtradeCashTransfers'
import { useDxtradeOrderCashAdjustments } from './useDxtradeOrderCashAdjustments'
import { useDxtradeOrdersHistory } from './useDxtradeOrdersHistory'

export interface PositionCashAdjustments {
  commission: { total: number; currency: string | null } | null
  overnightFees: { total: number } | null
}

export function usePositionCashAdjustments(
  accountCode: string,
  positionCode: string
): PositionCashAdjustments {
  const { data: ordersHistory } = useDxtradeOrdersHistory(accountCode, {
    positionEffect: 'OPEN',
  })

  const openOrder = useMemo(
    () =>
      ordersHistory?.orders?.find((order) =>
        order.legs?.some((leg) => leg.positionCode === positionCode)
      ),
    [ordersHistory?.orders, positionCode]
  )

  const { commission } = useDxtradeOrderCashAdjustments(openOrder)

  const { data: cashTransfersData } = useDxtradeCashTransfers(accountCode)

  const overnightFees = useMemo(
    () => sumOvernightFeesForPosition(cashTransfersData?.cashTransfers, positionCode),
    [cashTransfersData?.cashTransfers, positionCode]
  )

  return { commission: commission ?? null, overnightFees }
}
